@import '../../global/accessibility.css';


.nj-dm-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;

  width: 100%;

  z-index: 100;
  transform: translateX(100%);
  transition: transform .35s .25s;
  //display: none;
  padding: 0;

  background-color: #fff;
}

.nj-dm-overlay.visible {
  display: flex;
  transform: translateX(0);
  transition: transform .3s;
}

.nj-dm-dialog__header {
    background: #fff;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 35px;
    z-index: 999;
}


.nj-dm-btn-close {
  display: block;
  width: 35px;
  height: 35px;
  margin: 0 20px 0 auto;

  background: transparent;
  border: none;
  cursor: pointer;

  color: #666;
  font-size: 35px;

  z-index: 999;

  &:hover,
  &:focus {
      color: #000;
  }
}

.nj-dm-dialog {
  position: relative;
  margin: 0;
  display: block;
  width: 100%;

  background-color: #ffffff;
  overflow-y: auto;
  max-height: 100%;
  //min-height: 300px;
}

.nj-dm-dialog__container {
    padding: 35px 20px 20px;
}

.nj-dm-dialog__content {
  padding: 0;
  overflow-y: auto;
}

.nj-dm-dialog__buttons {
  text-align: right;
  position: sticky;
  bottom: 0;
  right: 0;
  background: #fff;
}

.nj-dm-dialog__buttons .action-btn,
.nj-dm-dialog__buttons .secundary-btn {
  background: #e2002a;
  border: 1px solid #e2002a;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  width: auto;
  display: inline-block;
  text-align: center;
  padding: 8px 16px;
  margin: 2px 2px 2px 0;
  max-width: 350px;
  text-decoration: none;
  cursor: pointer;
}

.nj-dm-dialog__buttons .secundary-btn {
  background: #666;
  border: 1px solid #666;
}

.nj-dm-dialog__buttons .secundary-btn:hover,
.nj-dm-dialog__buttons .secundary-btn:focus {
  background: #fff;
  color: #666;
}
.nj-dm-dialog__buttons .action-btn:hover,
.nj-dm-dialog__buttons .action-btn:focus {
  background: #fff;
  color: #e2002a;
}
